import axios from 'axios'
import qs from 'qs'
import { Message, MessageBox } from 'element-ui'
// 创建axios实例
const service = axios.create({
    baseURL: process.env.BASE_API, // api的base_url
    crossDomain: true,
    timeout: 40000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8';
    
    if(window.localStorage) {
        let token = window.localStorage.getItem('userToken');
        if(token != undefined && token.length > 10) {          
            if (config.data) {
                config.data.token = token;
            } else [
                config.data = {
                    token: token
                }
            ]
        }
    }    
    config.data = qs.stringify(config.data) // 转为formdata数据格式

    //console.log('request拦截器',config)
    return config
}, error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
    response => {
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
        // 否则的话抛出错误
        console.log('响应拦截器-200')
        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        console.log('响应拦截器-error',error)
        return Promise.reject(error.response);
        if (error.response.status) {
            switch (error.response.status) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 401:
                    MessageBox.alert("身份验证失败，请关闭重新进入。", {
                        type: "error"
                    });
                    break;

                    // 403 token过期
                    // 登录过期对用户进行提示
                    // 清除本地token和清空vuex中token对象
                    // 跳转登录页面
                case 403:
                    MessageBox.alert("登录过期，请关闭重新进入。", {
                        type: "error"
                    });
                    // 清除token
                    break;

                    // 404请求不存在
                case 404:
                    MessageBox.alert("您访问的网页不存在。", {
                        type: "error"
                    });
                    break;
                    // 其他错误，直接抛出错误提示
                default:
                    console.log()
                    MessageBox.alert(error.response.data.message, {
                        type: "error"
                    });
            }
            return Promise.reject(error.response);
        }
    }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js